import { __rest } from 'tslib';
import React from 'react';
import Icon from '@ant-design/icons';
import { I as IconBase } from '../IconBase-df74767e.js';

const IconComponent = (props, ref) => {
    const data = {
        tag: 'svg',
        attr: { viewBox: '0 0 24 24', fill: 'none' },
        child: [
            {
                tag: 'path',
                attr: {
                    fillRule: 'evenodd',
                    clipRule: 'evenodd',
                    d: 'M6.53843 12.4596C6.25007 12.757 5.77526 12.7643 5.47789 12.4759C5.18053 12.1876 5.17322 11.7128 5.46158 11.4154L11.4616 5.22789C11.6028 5.08222 11.7971 5 12 5C12.2029 5 12.3972 5.08222 12.5384 5.22789L18.5384 11.4154C18.8268 11.7128 18.8195 12.1876 18.5221 12.4759C18.2247 12.7643 17.7499 12.757 17.4616 12.4596L12.75 7.6008V17.7812C12.75 18.1955 12.4142 18.5312 12 18.5312C11.5858 18.5312 11.25 18.1955 11.25 17.7812V7.6008L6.53843 12.4596Z',
                    fill: '#A7ABC3',
                },
            },
        ],
    };
    const { style } = props;
    const _a = style || {}, { fontSize, color: passColor } = _a, rest = __rest(_a, ["fontSize", "color"]);
    const size = fontSize || 16;
    const color = passColor;
    return (React.createElement(Icon, Object.assign({}, props, { style: rest, ref: ref, component: () => (React.createElement(IconBase, { color: color, size: size, data: data, overrideColor: true })) })));
};
const UpLineOutlined = React.forwardRef(IconComponent);
UpLineOutlined.displayName = 'UpLineOutlined';

export { UpLineOutlined };
